export const MeterType = Object.freeze({
    Unknown: 0,
    Mitax300: 1,
    Mitax400: 2,
    Semel: 3,
    Frogne: 4
});

export const MeterTypeMixin = {
    data() {
        return {
            meterTypes: MeterType
        };
    },
    methods: {
        meterTypeToText(value) {
            const translations = {
                [MeterType.Unknown]: "Unknown",
                [MeterType.Mitax300]: "Mitax 300",
                [MeterType.Mitax400]: "Mitax 400",
                [MeterType.Semel]: "Semel",
                [MeterType.Frogne]: "Frogne"
            };
            return translations[value] || "Unknown";
        }
    }
};
